import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

import { withStyles } from '@material-ui/core';
import useDesktop from '@hooksV2/useDesktop';
import {
  getDocumentPath,
  getDocumentFileType,
  getOriginalDocumentPath,
} from '../../../../../../utils/documents';
import styles from './style';
import FileViewer from '../../../../../../components/FileViewer';
import Page from '../../../../../../components/layouts/WithHeader';

import ErrorContainer from '../../../../../../components/ErrorContainer';
import { sGetDocuments } from '../../../../../../store/reducers/documents';
import CirclesLoader from '../../../../../../components/loaders/CirclesLoader';
import { fetchDocument as apiFetchDocument } from '../../../../../../api/documents';
import { fetchPersonalDocument as apiFetchPersonalDocument } from '../../../../../../api/propertyowners';
import ShowErrorMessage from '../../../../../../components/ShowErrorMessage';
import { sGetPersonalDocuments } from '../../../../../../store/reducers/personalDocuments';

const Show = ({
  classes,
  document,
  fetching,
  fetchingError,
  isPersonalDocument,
}) => {
  const location = useLocation();
  const { documentId } = useParams();
  const isDesktop = useDesktop();

  const [documentPath, setDocumentPath] = useState(null);
  const [isConvertedFile, setIsConvertedFile] = useState(false);
  const [fileType, setfileType] = useState(null);
  const [isError, setIsError] = useState(false);

  const supportedFileTypes = [
    'txt',
    'docx',
    'doc',
    'xlsx',
    'xls',
    'pptx',
    'ppt',
    'rtf',
  ];

  const fetchFullDocument = async () => {
    let error;
    let data;

    if (isPersonalDocument) {
      [error, data] = await apiFetchPersonalDocument(documentId);
    } else {
      [error, data] = await apiFetchDocument(documentId);
    }
    const response = data || error;
    return response;
  };

  const startTimer = (type) => {
    let count = 0;
    const timer = setInterval(() => {
      if (count === 3 || (count > 3 && count < 8 && !documentPath)) {
        fetchFullDocument().then(async (response) => {
          if (response && (response.pdfconversion || response?.pdfFilePath)) {
            clearInterval(timer);
            const path = await getDocumentPath(response);
            setIsConvertedFile(true);
            setDocumentPath(path);
          }
        });
      }

      if (count > 8) {
        if (!documentPath && supportedFileTypes.includes(type)) {
          setIsError(true);
        }

        clearInterval(timer);
      }
      count += 1;
    }, 5000);
  };

  const LoadingUI = () => {
    if (
      !documentPath &&
      supportedFileTypes.includes(fileType) &&
      location.state &&
      location.state.newUpload
    ) {
      return (
        <div
          style={{
            maxWidth: '500px',
            margin: '5% auto 0',
            height: '200px',
            padding: 20,
            textAlign: 'center',
            color: '#fff',
          }}
        >
          <CirclesLoader style={{ width: 50, height: 20, marginTop: '16px' }} />
          <p style={{ marginTop: '36px', marginBottom: '36px' }}>
            Dokumentet konverteres til PDF og vil snart vises her. Du kan
            navigere rundt i appen så lenge.
          </p>
        </div>
      );
    }
    return null;
  };

  const getFileTypeDoc = (file) =>
    new Promise((resolve) => {
      if (file && file.url) {
        resolve(file.url.fileType);
      }
    });

  useEffect(() => {
    if (document) {
      setDocumentPath(getDocumentPath(document));
      if (document.pdfconversion || document?.pdfFilePath) {
        setIsConvertedFile(true);
      }
      setfileType(getDocumentFileType(document));
    }

    if (document && location.state) {
      if (documentPath) {
        setDocumentPath(documentPath);
      }
    }
  }, [document, documentPath, fileType, location]);

  useEffect(() => {
    if (location.state && location.state.newUpload) {
      if (documentPath) {
        setDocumentPath(getDocumentPath(documentPath));
        if (document.pdfconversion || document?.pdfFilePath) {
          setIsConvertedFile(true);
        }
      } else {
        getFileTypeDoc(document).then((res) => {
          if (supportedFileTypes.includes(res)) {
            startTimer(res);
          }
        });
      }
    }
  }, [document]);

  if (fetchingError) {
    return <ErrorContainer errorResponse={fetchingError} />;
  }
  return (
    <>
      <Page
        noPaddingTop
        minFullHeight
        hideHeader
        noPadding
        maxWidth={false}
        className={isDesktop ? classes.previewPage : classes.previewPageMobile}
        contentClass={classes.contentClass}
      >
        {!documentPath && !isError && LoadingUI()}
        {document?.documentFileAvailable && isError && (
          <ShowErrorMessage
            documentOriginalPath={getOriginalDocumentPath(document)}
          />
        )}
        {document && !document?.documentFileAvailable && (
          <ShowErrorMessage noFile />
        )}
        {documentPath && document?.documentFileAvailable && !isError && (
          <>
            <FileViewer
              document={documentId}
              documentData={document}
              fetching={fetching}
              filePath={documentPath}
              fileType={getDocumentFileType(document)}
              className={classes.filePreview}
              isConvertedFile={isConvertedFile}
            />
          </>
        )}
      </Page>
    </>
  );
};

const mapStateToProps = (state) => ({
  documents: sGetDocuments(state),
  personalDocuments: sGetPersonalDocuments(state),
});

export default connect(mapStateToProps)(withStyles(styles)(Show));
